import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { SequenceName } from "./LinearView/SequenceName";
import classNames from "classnames";
export function SimpleOligoPreview({
  className,
  width,
  height,
  sequenceData,
  showTitle
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width,
        height,
        paddingLeft: 5,
        display: "flex",
        flexDirection: "column"
      },
      className: classNames("tg-simple-oligo-viewer", className),
      children: [
        showTitle && /* @__PURE__ */ jsx(
          SequenceName,
          {
            ...{
              isProtein: sequenceData.isProtein,
              sequenceName: sequenceData.name || "",
              sequenceLength: sequenceData.sequence ? sequenceData.sequence.length : 0
            }
          }
        ),
        /* @__PURE__ */ jsx("div", { style: { height: "100%", overflow: "auto", wordBreak: "break-all" }, children: sequenceData.sequence || "" })
      ]
    }
  );
}
